<template>
	<MasterAwbcreated-component>
		<div class="animated fadeIn">
		 <b-row>
            <b-col sm="12">
              <b-card>
			   <div id="overlay" >
					<div class="loader"></div>
				</div>
            	<div slot="header">
                 <strong>MasterAwb Created</strong>
			    </div>
				<b-row>
					<b-col cols="4">
						<b-form-group label="From Date : "  :label-cols="3" >
						<v-date-picker
							mode="single"
							input-class="dateInput"
							:available-dates="{ start: null, end: new Date() }"
							v-model="fromDate"
						>
						</v-date-picker>
						</b-form-group>
					</b-col>
					<b-col cols="4">
						<b-form-group label="To Date : "  :label-cols="3" >
						<v-date-picker
							mode="single"
							input-class="dateInput"
							:available-dates="{ start: null, end: new Date() }"
							v-model="toDate"
						>
						</v-date-picker>
						</b-form-group>
					</b-col>
					<b-col cols="2" style="text-align:left;">
						<b-form-group>
						<button class="btn btn-primary" @click="createdMasterawbListForKsa()"> Search </button>                       
						<button class="btn btn-danger ml-1" @click="refresh()"> <i class="fa fa-refresh"></i> </button>                       
						</b-form-group>
					</b-col>
				</b-row>
			    <b-col sm="12" class="text-right">
	               <p > <b>Total Records :<span style="color:red;">{{totalRows}}</span></b> </p>
                </b-col> 
			    <b-table 
				responsive show-empty  :busy="isBusy" :items="createditem" :fields="createdfields"  :current-page="currentPage" :per-page="perPage" :filter="filter"   :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered" :bordered="bordered" id="mytable">

                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
					<template slot="shipment_count" slot-scope="row">
							<button title="View Shipment" @click="viewShipment(row.item.master_awb)" style="background-color:white !important;" class="btn btn-link"  v-if="row.item.shipment_count==null">
											
								<span style="color:#1b8eb7"> 0</span>
						
						</button>

						<button title="View Shipment" @click="viewShipment(row.item.master_awb)" style="background-color:white !important;" class="btn btn-link" v-else >
							<span style="color:#1b8eb7"> {{row.item.shipment_count}}</span>
						
						</button>
           			</template>

				    <template slot="action" slot-scope="row" v-if="pickuplocationmasterid == 365 ">
						<button title="Create Challan" class="btn btn-success" @click="showCreatechallanModal(row.item)" v-if="row.item.challan_data == null" @mouseover="populateChallanData(row.item)">
						   Create Challan
						</button>
						<div v-if="row.item.challan_data != null" @mouseover="populateChallanData(row.item)">
							<button title="Edit Challan" class="btn btn-success mr-2" @click="showCreatechallanModal(row.item)" >
								<i class="fa fa-edit"></i>
							</button>
							<button title="Download Challan" class="btn btn-success" >
								<i class="fa fa-download" @click="showChallanDownloadModal(row.item)"></i>
							</button>
						</div>
					</template>

               </b-table>
               <b-col md="12" class="my-1 " v-if="totalRows>10">
	            <!-- <b-pagination
	                v-model="currentPage"
	                :total-rows="totalRows"
	                :per-page="perPage"
	                class="my-0"
	              ></b-pagination> -->
					<b-pagination
						v-model="currentPage"
						:total-rows="rows"
						:per-page="perPage"
						aria-controls="mytable"
					></b-pagination>
          		</b-col> 



			<div class="table-responsive" id='pdf_el' v-if="createChallanModal == true">
					<h2 style="text-align:center; border:1px solid #DBCDCD" class="p-1 ml-1 mr-1">FIRSTCRY TRADING COMPANY</h2>
					<h4 style="text-align:center; border-top-style:none; border:1px solid #DBCDCD; margin-top:-9px;" class="p-1 ml-1 mr-1">LPC HANDOVER CHALLAN</h4>
					<b-row style="text-align:center; border:1px solid #DBCDCD; margin-top:-9px;" class="ml-1 mr-1">
						<b-col md="2" class="forborder"> Driver Name</b-col>
						<b-col md="2" class="forborder"> {{challanData.driver_name}}</b-col>
						<b-col md="2" class="forborder"> Origin</b-col>
						<b-col md="2" class="forborder"> {{challanData.origin_name}}</b-col>
						<b-col md="2" class="forborder"> Destination Hub</b-col>
						<b-col md="2" class="forborder"> {{challanData.destination_hub_name}}</b-col>
						
					</b-row>
					<b-row style="text-align:center; border:1px solid #DBCDCD" class="ml-1 mr-1">
						<b-col md="2" class="forborder"> Driver Mobile No.</b-col>
						<b-col md="2" class="forborder"> {{challanData.driverMobileNo}}</b-col>
						<b-col md="2" class="forborder"> Vehicle In Time</b-col>
						<b-col md="2" class="forborder"> {{challanData.vehicleInTime}}</b-col>
						<b-col md="2" class="forborder"> Vehicle Out Time</b-col>
						<b-col md="2" class="forborder"> {{challanData.vehicleOutTime}}</b-col>
						
					</b-row>
					<b-row style="text-align:center; border:1px solid #DBCDCD" class="ml-1 mr-1">
						<b-col md="2" class="forborder"> Acknowledgement</b-col>
						<b-col md="2" class="forborder"> {{challanData.acknowledgement}}</b-col>
						<b-col md="2" class="forborder"> Master WayBill No.</b-col>
						<b-col md="2" class="forborder"> {{challanData.master_awb}}</b-col>
						<b-col md="2" class="forborder"> Courier Company</b-col>
						<b-col md="2" class="forborder"> {{challanData.courierCompany}}</b-col>
						
					</b-row>
					<b-row style="text-align:center; border:1px solid #DBCDCD" class=" ml-1 mr-1">
						<b-col md="2" class="forborder"> Driver Sign</b-col>
						<b-col md="2" class="forborder"> </b-col>
						<b-col md="2" class="forborder"> Master WayBill Barcode</b-col>
						<b-col md="2"  class="forborder" > 
							<barcode class="barcodediv p-3" v-bind:value="selectedAwbId">
                         	 NA
                          	</barcode>
						</b-col>
						<b-col md="2" class="forborder"> Vehicle No.</b-col>
						<b-col md="2" class="forborder"> {{challanData.vehicleNo}}</b-col>
						
					</b-row>
					<b-row style="text-align:center; border:1px solid #DBCDCD" class="ml-1 mr-1">
						<b-col md="2" class="forborder"> Security Name</b-col>
						<b-col md="2" class="forborder"> {{challanData.securityName}}</b-col>
						<b-col md="2" class="forborder"> Handover By Name</b-col>
						<b-col md="2" class="forborder"> {{challanData.handoverByName}}</b-col>
						<b-col md="2" class="forborder"> Handover Date</b-col>
						<b-col md="2" class="forborder"> {{challanData.handoverDate}}</b-col>
						
					</b-row>
					<b-row style="text-align:center; border:1px solid #DBCDCD" class="ml-1 mr-1">
						<b-col md="2" class="forborder" > Security Sign</b-col>
						<b-col md="2" class="forborder" style="padding-top:50px; padding-bottom:50px;"> </b-col>
						<b-col md="2" class="forborder"> Handover By Sign</b-col>
						<b-col md="2" class="forborder"> </b-col>
						<b-col md="2" class="forborder"> Handover Time</b-col>
						<b-col md="2" class="forborder"> {{handoverTime}}</b-col>
						
					</b-row>

					<b-row style="text-align:center; border:1px solid #DBCDCD" class="p-2 ml-1 mr-1">
						<b-table 
							responsive show-empty  :items="shipmentawblist" :busy="isBusyshipment"  :fields="fields1"  :filter="filter" :striped="striped"  :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"   :bordered="bordered" id="shipmytable">
								<div slot="table-busy" class="text-center text-danger my-2">
							<b-spinner class="align-middle"></b-spinner>
							<strong>Loading...</strong>
							</div>
							<template slot="deliveryagent" slot-scope="row">
							
								{{selectedDriverName}}
							</template>

							</b-table>
						
					</b-row>

				
			</div>




			<b-modal size="xl" title="Create Challen" v-model="createChallanModal" hide-footer>
			<!-- {{this.masteAwbData}} -->
			 <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
				<div>
					<div class="row">
						<div class="col-md-4">
							<label>Driver Name </label>
							<input type="text" class="form-control" name="driver_name" v-model="challanData.driver_name" v-validate="'required|'" :class="{'input': true, 'is-danger': errors.has('form-1.driver_name') }" />
							<span v-show="errors.has('form-1.driver_name')" class="help text-danger">{{ errors.first('form-1.driver_name') }}</span>
						</div>
						<div class="col-md-4">
							<label>Origin </label>
							<input type="text" v-model="challanData.origin_name" class="form-control" disabled/>
						</div>
						<div class="col-md-4">
							<label>Destination Hub</label>
							<input type="text" v-model="challanData.destination_hub_name"  class="form-control" disabled/>
							
						</div>
						<div class="col-md-4 mt-2">
							<label>Driver Mobile No.</label>
							<input type="number" v-model="challanData.driverMobileNo" name="driverMobileNo" class="form-control" v-validate="'required|digits:10|between:1,10000000000000000|'" :class="{'input': true, 'is-danger': errors.has('form-1.driverMobileNo') }"/>
							<span v-show="errors.has('form-1.driverMobileNo')" class="help text-danger">{{ errors.first('form-1.driverMobileNo') }}</span>
						</div>
						<div class="col-md-4 mt-2">
							<label>Vehicle In Time</label>
							<input type="text" v-model="challanData.vehicleInTime" name="vehicleInTime" class="form-control" v-validate="'required|'" :class="{'input': true, 'is-danger': errors.has('form-1.vehicleInTime') }"/>
							<span v-show="errors.has('form-1.vehicleInTime')" class="help text-danger">{{ errors.first('form-1.vehicleInTime') }}</span>
						</div>
						<div class="col-md-4 mt-2">
							<label>Vehicle Out Time</label>
							<input type="text" v-model="challanData.vehicleOutTime" name="vehicleOutTime"  class="form-control" v-validate="'required|'" :class="{'input': true, 'is-danger': errors.has('form-1.vehicleOutTime') }"/>
							<span v-show="errors.has('form-1.vehicleOutTime')" class="help text-danger">{{ errors.first('form-1.vehicleOutTime') }}</span>
						</div>
						<div class="col-md-4 mt-2">
							<label>Acknowledgement </label>
							<textarea type="text" v-model="challanData.acknowledgement"
							class="form-control" disabled cols="10" rows="2" style="overflow: hidden;">All Shipment Received in Proper Condition with mentioned count
							 </textarea>
						
						</div>
						<div class="col-md-4 mt-2">
							<label>Master WayBill No.</label>
							<input type="text" class="form-control" v-model="challanData.master_awb" disabled/>
							
						</div>
						<div class="col-md-4 mt-2">
							<label>Courier Company</label>
							<input type="text" v-model="challanData.courierCompany" name="courierCompany"  class="form-control" disabled/>
							
						</div>
						<div class="col-md-4 mt-2">
							<label>Driver Sign</label>
							<!-- <input type="text" class="form-control" hidden /> -->
						</div>
						<div class="col-md-4 mt-2">
							<label>Master WayBill Barcode </label>
							<!-- {{selectedAwbId}} -->
							<barcode v-bind:value="selectedAwbId">
                         	 NA
                          	</barcode>
						</div>
						<div class="col-md-4 mt-2">
							<label>Vehicle No.</label>
							<input type="text" v-model="challanData.vehicleNo" name="vehicleNo"  class="form-control" v-validate="'required|'" :class="{'input': true, 'is-danger': errors.has('form-1.vehicleNo') }"/>
							<span v-show="errors.has('form-1.vehicleNo')" class="help text-danger">{{ errors.first('form-1.vehicleNo') }}</span>
						</div>
						<div class="col-md-4 mt-2">
							<label>Security Name</label>
							<input type="text" v-model="challanData.securityName"  name="securityName" class="form-control" v-validate="'required|'" :class="{'input': true, 'is-danger': errors.has('form-1.securityName') }"/>
							<span v-show="errors.has('form-1.securityName')" class="help text-danger">{{ errors.first('form-1.securityName') }}</span>
						</div>
						<div class="col-md-4 mt-2">
							<label>Handover By Name</label>
							<input type="text" v-model="challanData.handoverByName"  name="handoverByName" class="form-control" v-validate="'required|'" :class="{'input': true, 'is-danger': errors.has('form-1.handoverByName') }"/>
							<span v-show="errors.has('form-1.handoverByName')" class="help text-danger">{{ errors.first('form-1.handoverByName') }}</span>
						</div>
						<div class="col-md-4 mt-2">
							<label>Handover Date</label>
							<!-- <v-date-picker  mode='single'  :available-dates='{ start: new Date(), end: null }' v-model='selectedhandoverdatachallanData'> -->

                      <!-- </v-date-picker> -->
					  <input type="date" class="form-control" v-model="challanData.handoverDate" required  :min="minDate" />
							<!-- <input type="text" v-model="challanData.handoverDate" name="handoverDate"  class="form-control" v-validate="'required|alpha_dash'" :class="{'input': true, 'is-danger': errors.has('form-1.handoverDate') }"/>
							<span v-show="errors.has('form-1.handoverDate')" class="help text-danger">{{ errors.first('form-1.handoverDate') }}</span> -->
						</div>
						<div class="col-md-2 mt-2">
							<label> Security Sign</label>
							<!-- <input type="text" class="form-control" hidden/> -->
						</div>
						<div class="col-md-2 mt-2">
							<label>Handover By Sign</label>
							<!-- <input type="text" class="form-control" hidden /> -->
						</div>
						
						<div class="col-md-4 mt-2">
							<label>Handover Time</label>
							<input type="text" v-model="challanData.handoverTime" name="handoverTime"  class="form-control" v-validate="'required|'" :class="{'input': true, 'is-danger': errors.has('form-1.handoverTime') }"/>
							<span v-show="errors.has('form-1.handoverTime')" class="help text-danger">{{ errors.first('form-1.handoverTime') }}</span>
						</div>
						<div class="col-md-4 mt-2">
							<label>Optional</label>
							<input type="text" class="form-control" v-model="optional"  />
						</div>
					</div>

					<b-row>
						<b-col sm="12" class="text-right mt-3">
							<p > <b>Total Records :<span style="color:red;">{{total_row_shipment }}</span></b> </p>
							</b-col> 
							<b-col sm="12">
								<b-table 
								responsive show-empty  :items="shipmentawblist" :busy="isBusyshipment"  :fields="fields1" :current-page="shipcurrentPage" :per-page="shipperPage" :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" id="shipmytable">
									<div slot="table-busy" class="text-center text-danger my-2">
								<b-spinner class="align-middle"></b-spinner>
								<strong>Loading...</strong>
								</div>
								<template slot="deliveryagent" slot-scope="row">
							
								{{challanData.driver_name}}
							</template>
								</b-table>
							</b-col>
							<b-col md="12" class="my-1 ">

							<b-pagination
								v-model="shipcurrentPage"
								:total-rows="shiprows"
								:per-page="shipperPage"
								aria-controls="shipmytable"
							></b-pagination>
						</b-col> 
					</b-row>
				</div>

				 <b-col md="6" style="float:right; max-width:17%;">
                  <b-button type="submit" size="md" class="mr-2" variant="primary"> Submit</b-button>
                  <b-button type="button" size="md" variant="danger" @click="clearCreateChallanModal"> Close</b-button>               
                </b-col>

			 </form>

			</b-modal>

			<!-- Challan donwload modal -->
			<b-modal size="xl" v-model="challanDownloadModal" hide-footer>
				 <div class="table-responsive" id='pdf_element' style="overflow: auto;">
					<h2 style="text-align:center; border:1px solid #DBCDCD" class="p-1 ml-1 mr-1">FIRSTCRY TRADING COMPANY</h2>
					<h4 style="text-align:center; border-top-style:none; border:1px solid #DBCDCD; margin-top:-9px;" class="p-1 ml-1 mr-1">LPC HANDOVER CHALLAN</h4>
					<b-row style="text-align:center; border:1px solid #DBCDCD; margin-top:-9px;" class="ml-1 mr-1">
						<b-col md="2" class="forborder"> Driver Name</b-col>
						<b-col md="2" class="forborder"> {{challanData.driver_name}}</b-col>
						<b-col md="2" class="forborder"> Origin</b-col>
						<b-col md="2" class="forborder"> {{challanData.origin_name}}</b-col>
						<b-col md="2" class="forborder"> Destination Hub</b-col>
						<b-col md="2" class="forborder"> {{challanData.destination_hub_name}}</b-col>
						
					</b-row>
					<b-row style="text-align:center; border:1px solid #DBCDCD" class="ml-1 mr-1">
						<b-col md="2" class="forborder"> Driver Mobile No.</b-col>
						<b-col md="2" class="forborder"> {{challanData.driverMobileNo}}</b-col>
						<b-col md="2" class="forborder"> Vehicle In Time</b-col>
						<b-col md="2" class="forborder"> {{challanData.vehicleInTime}}</b-col>
						<b-col md="2" class="forborder"> Vehicle Out Time</b-col>
						<b-col md="2" class="forborder"> {{challanData.vehicleOutTime}}</b-col>
						
					</b-row>
					<b-row style="text-align:center; border:1px solid #DBCDCD" class="ml-1 mr-1">
						<b-col md="2" class="forborder"> Acknowledgement</b-col>
						<b-col md="2" class="forborder"> {{challanData.acknowledgement}}</b-col>
						<b-col md="2" class="forborder"> Master WayBill No.</b-col>
						<b-col md="2" class="forborder"> {{challanData.master_awb}}</b-col>
						<b-col md="2" class="forborder"> Courier Company</b-col>
						<b-col md="2" class="forborder"> {{challanData.courierCompany}}</b-col>
						
					</b-row>
					<b-row style="text-align:center; border:1px solid #DBCDCD" class=" ml-1 mr-1">
						<b-col md="2" class="forborder"> Driver Sign</b-col>
						<b-col md="2" class="forborder"> </b-col>
						<b-col md="2" class="forborder"> Master WayBill Barcode</b-col>
						<b-col md="2"  class="forborder" > 
							<barcode class="barcodediv" v-bind:value="selectedAwbId">
                         	 NA
                          	</barcode>
						</b-col>
						<b-col md="2" class="forborder"> Vehicle No.</b-col>
						<b-col md="2" class="forborder"> {{challanData.vehicleNo}}</b-col>
						
					</b-row>
					<b-row style="text-align:center; border:1px solid #DBCDCD" class="ml-1 mr-1">
						<b-col md="2" class="forborder"> Security Name</b-col>
						<b-col md="2" class="forborder"> {{challanData.securityName}}</b-col>
						<b-col md="2" class="forborder"> Handover By Name</b-col>
						<b-col md="2" class="forborder"> {{challanData.handoverByName}}</b-col>
						<b-col md="2" class="forborder"> Handover Date</b-col>
						<b-col md="2" class="forborder"> {{challanData.handoverDate}}</b-col>
						
					</b-row>
					<b-row style="text-align:center; border:1px solid #DBCDCD" class="ml-1 mr-1">
						<b-col md="2" class="forborder" > Security Sign</b-col>
						<b-col md="2" class="forborder" style="padding-top:50px; padding-bottom:50px;"> </b-col>
						<b-col md="2" class="forborder"> Handover By Sign</b-col>
						<b-col md="2" class="forborder"> </b-col>
						<b-col md="2" class="forborder"> Handover Time</b-col>
						<b-col md="2" class="forborder"> {{challanData.handoverTime}}</b-col>
						
					</b-row>
					<b-row style="text-align:center; border:1px solid #DBCDCD" class="ml-1 mr-1">
						<b-col md="2" class="forborder" > Optional</b-col>
						<b-col md="10" class="forborder1">{{optional}} </b-col>
						<!-- <b-col md="2" class="forborder"> Handover By Sign</b-col>
						<b-col md="2" class="forborder"> </b-col>
						<b-col md="2" class="forborder"> Handover Time</b-col>
						<b-col md="2" class="forborder"> {{handoverTime}}</b-col> -->
						
					</b-row>
					<b-row style="text-align:center; border:1px solid #DBCDCD" class="p-2 ml-1 mr-1">
						<b-table 
							responsive show-empty  :items="shipmentawblist" :busy="isBusyshipment"  :fields="fields1"  :filter="filter" :striped="striped"  :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"   :bordered="bordered" id="shipmytable">
								<div slot="table-busy" class="text-center text-danger my-2">
								<b-spinner class="align-middle"></b-spinner>
								<strong>Loading...</strong>
								</div>

							<template slot="deliveryagent" slot-scope="row">
							
								{{selectedDriverName}}
							</template>
							</b-table>
						
					</b-row>

					 <b-col md="6" style="float:right; max-width:17%;" class="m-2" id="downloadfooter">
						<b-button type="submit" size="md" class="mr-2" variant="primary" @click="downloadChalla()"> Download</b-button>
						<b-button type="button" size="md" variant="danger" @click="closechallanDownloadModal"> Ok</b-button>               
					</b-col>

				
			</div>

			</b-modal>

			<!-- end challan download modal -->

			<!-- ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
				
				<b-modal size="lg" title="MasterAwb Shipment Log" v-model="shipmentModal" hide-footer>
				<b-row>
				<b-col sm="12" class="text-right">
				
					<b-button v-if="total_row_shipment>0"  style="float: right;" @click="awbforkasdownloadCSV()"
						size="md" variant="primary">Download</b-button>
						<br><br>
				<p > <b>Total Records :<span style="color:red;">{{total_row_shipment }}</span></b> </p>
				</b-col> 
				<b-col sm="12">
					<b-table 
					responsive show-empty  :items="shipmentawblist" :busy="isBusyshipment"  :fields="fields" :current-page="shipcurrentPage" :per-page="shipperPage" :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" id="shipmytable">
						<div slot="table-busy" class="text-center text-danger my-2">
							<b-spinner class="align-middle"></b-spinner>
							<strong>Loading...</strong>
						</div>
					</b-table>
				</b-col>
				<b-col md="12" class="my-1 ">
				<!-- <b-pagination
					v-model="shipcurrentPage"
					:total-rows="total_row_shipment"
					:per-page="shipperPage"
					class="my-0"
				></b-pagination> -->
						<b-pagination
							v-model="shipcurrentPage"
							:total-rows="shiprows"
							:per-page="shipperPage"
							aria-controls="shipmytable"
						></b-pagination>
					</b-col> 
					</b-row>
				</b-modal>
              </b-card>
            </b-col>
         </b-row>
		</div>
	</MasterAwbcreated-component>
</template>
<script>
import Swal from 'sweetalert2'
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Vue from 'vue';
import VueBarcode from 'vue-barcode';
import html2pdf from 'html2pdf.js'
export default {
	data(){
		return{
			outlined:true,
	        bordered: true,
			striped: false,
	        sortDesc: false,
	        allowCustomValue : true,
	        sortDirection: 'desc',
	        filter: null,
	        sortBy: null,
			isBusy:false,
			pageOptions: [5, 10, 15],
			currentPage:1,
			perPage:  10,
			createditem:[],
	        createdfields:[
	        {key: 'deliveryagentname', label: 'Rider Name'},
	        {key: 'master_awb', label: 'Master AWB'},
		    {key: 'status', label: 'Status'},
		    {key: 'shipment_count', label: 'Shipment Count'},
		    {key: 'created_date', label: 'Created Date'}, 
			{key: 'action', label: 'Action'},    
	        ],
	        totalRows:0,
	        shipmentModal:false,
	        shipmentawblist:[],
	        fields:[
	          { key: 'shipmentId', label: 'Shipping Id', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
	           { key: 'masterAwb', label: 'Master AWB', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
	          { key: 'shipmentstatus', label: 'Shipment Status', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
	           { key: 'deliverystatus', label: 'Delivery Status', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
	       ],

		    fields1:[
	          { key: 'shipmentId', label: 'Shipping Id', tdClass: 'nameOfTheClass' },
	           { key: 'masterAwb', label: 'Master AWB', tdClass: 'nameOfTheClass' },
	          { key: 'shipmentstatus', label: 'Shipment Status', tdClass: 'nameOfTheClass' },
	           { key: 'deliverystatus', label: 'Delivery Status', tdClass: 'nameOfTheClass' },
			   { key: 'deliveryagent', label: 'Delivery Agent Name', tdClass: 'nameOfTheClass' },
	       ],


            total_row_shipment:0,
            isBusyshipment:false,	
			shipcurrentPage:1,
			shipperPage:10,
			selectedmaterAWB : '',
			createChallanModal: false,
			masteAwbData:'',
			selectedAwbId:'',
			driver_name:'',
			
			driverMobileNo:"",
			vehicleInTime:"",
			vehicleOutTime:'',
			origin_name:'Riyadh LPC',
			acknowledgement : "All Shipment Received in Proper Condition with mentioned count",
			courierCompany: "FirstCry Express",
			vehicleNo:"",
			securityName:"",
			handoverByName:"",
			handoverDate:"",
			handoverTime:'',
			optional:"",
			createchallanobject:{},
			challanData:{},
			refObj:{},
			challanDownloadModal: false,
			pdfContent: '',
			pickuplocationmasterid:"",
			selectedDriverName: '',
			selectedDate: new Date(),
			minDate: '',

			toDate:new Date(),
        	fromDate:new Date(),
		}
	},
	mounted() 
	{
		// Get today's date in YYYY-MM-DD format
		var today = new Date();
		var dd = today.getDate();
		var mm = today.getMonth() + 1; // January is 0!
		var yyyy = today.getFullYear();
		if (dd < 10) {
			dd = '0' + dd;
		}
		if (mm < 10) {
			mm = '0' + mm;
		}
		this.minDate = yyyy + '-' + mm + '-' + dd;
	},

	created(){
		this.createdMasterawbListForKsa();
	},
	components: {
    'barcode': VueBarcode
  },
	computed: {
      rows() {
        return this.createditem.length
      },
	  shiprows() {
        return this.shipmentawblist.length
      }
    },
	 watch: {
    'masteAwbData.master_awb': function(newVal, oldVal) {
      
      this.myEvent(newVal );
    }
  },
	methods: {
		createdMasterawbListForKsa(){
		  var userdata = localStorage.getItem('userData')
	      var userInfo = JSON.parse(userdata)
		  this.pickuplocationmasterid= userInfo.pickuplocationmasterid
	      this.isBusy = true;

		  if(this.fromDate > this.toDate){
			this.$fire({
				text: "From date must be smaller than To date",
				type: "warning",
				timer: 30000
			}); 
			this.isBusy = false;
			return
			}
	      const Obj_listing = {
	    		status:'Created',
	            hub_id:`${userInfo.pickuplocationmasterid}`,
				from_date: this.fromDate ? this.formatDate(this.fromDate) : null,
            	to_date: this.toDate ? this.formatDate(this.toDate) : null,
	                }
	      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getStatusWiseMasterawbListForKsa`,Obj_listing)
	            .then((result) => {
	           
           
          this.isBusy = false;
          if (result.body.returnmsg =="Successful") {
                
             this.createditem = result.body.returnvalue
                  
             this.totalRows = result.body.returnvalue.length;
 
              } 
              else {
                this.createditem=[];
                this.totalRows=0;  
              }
            })
            .catch((ex) => {
              console.log('error', ex)
            })
		},
		viewShipment(masterAwb){
			this.selectedmaterAWB = masterAwb;
			console.log("masterawbbbbbbbbbb",masterAwb)
			this.masterawbShipmentlist(masterAwb);
			// this.isBusyshipment=false;
			this.shipmentModal=true;

		},
		
		masterawbShipmentlist: function(masterAwb) {
		
		console.log("Master",masterAwb);
		var userdata = localStorage.getItem('userData')
		var userInfo = JSON.parse(userdata)
		this.isBusyshipment=true;
		var Obj = {
			
			master_awb:masterAwb,
		
		};  
		console.log("TYYY",Obj);
	

			this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getShipmentlistOfMasterawbForKsa`,Obj)
			.then((result) => {
			console.log(result);
			this.isBusyshipment=false;
			if (result.body.returnmsg === 'Successful') {
				
			this.shipmentawblist=result.body.returnvalue;
			console.log("ppppppppppppppppp",this.shipmentawblist)
			this.total_row_shipment=result.body.returnvalue.length;
				
			} 
			else {
				this.isBusyshipment=false;
			this.shipmentawblist=[];
			this.total_row_shipment=0;
			}
			})
			.catch((ex) => {
			console.log('error-----', ex)
			})   
		},

		awbforkasdownloadCSV: function() {
            document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            var csvObj = {
                sysusermasterid: `${userInfo.sysusermasterid}`,
                master_awb:this.selectedmaterAWB
            };
			console.log("ooooooooooooooooooo",csvObj)
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getShipmentlistReportOfMasterawbForKsa`,csvObj)
                .then((result) => {
                console.log(result.url);
                document.getElementById("overlay").style.display = "none";
                if (result.body == "success") {
                    // alert("Please Check Ur Mail For Downlod Link");
					this.$fire({
						text:"Please Check Your Mail For Downlod Link",
						type: "success",
						timer: 30000
					}); 
                } else {
                    // alert("Can not Download");
					this.$fire({
						text:"Can not Download",
						type: "error",
						timer: 30000
					}); 
                }
            });
        },

		showCreatechallanModal(value){
			console.log("challanData--------------->",this.challanData)
			this.masteAwbData = value
			console.log("this.masteAwbData",this.masteAwbData)
			this.createChallanModal = true;
			this.masterawbShipmentlist(this.masteAwbData.master_awb)
		},

		 myEvent(val) {
			this.selectedAwbId = val
    
   		 },

		 validateForm(scope){
			
			this.$validator.validateAll(scope).then(result => {
			if (result) { 

				// const createObje ={

				// 	"driver_name": this.challanData.driver_name ,
				// 	"origin_name": this.origin_name,
				// 	"destination_hub_name": this.masteAwbData.destination_hub_name,
				// 	"driverMobileNo": this.driverMobileNo ,
				// 	"vehicleInTime": this.vehicleInTime,
				// 	"vehicleOutTime": this.vehicleOutTime,
				// 	"acknowledgement": this.acknowledgement,
				// 	"master_awb": this.masteAwbData.master_awb,
				// 	"vehicleNo": this.vehicleNo,
				// 	"securityName": this.securityName,
				// 	"handoverByName": this.handoverByName,
				// 	"handoverDate": this.handoverDate,
				// 	"handoverTime": this.handoverTime,
				// 	"courierCompany" : this.courierCompany

				// }

			// console.log(createObje)

			this.submitchallan();

				
			}
			});
			
			
		 },

		 submitchallan(){
			document.getElementById("overlay").style.display = "block";
			this.createchallanobject  = JSON.stringify(this.challanData)
			console.log('this.createchallanobject------------------->',this.createchallanobject)
			
			const Obj ={
				challan_data : this.createchallanobject,
				master_awb : this.masteAwbData.master_awb
			}

				this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/saveChallanData`,Obj)
				.then((result) => {
				
				console.log(result.url);
				document.getElementById("overlay").style.display = "none";
				if (result.body.returnmsg == "Successful") {

					this.$fire({
						text:"Data Submitted Successfully",
						type: "success",
						timer: 30000
					}); 
					this.createChallanModal = false;
					this.createdMasterawbListForKsa();
				} else {
					this.$fire({
						text:"Please Try again!",
						type: "error",
						timer: 30000
					}); 
				}
			});
		 },

		 clearCreateChallanModal(){
			this.challanData ={...this.refObj}
			this.createChallanModal = false;

		 },

		 generatePDF: async function(){

			// this.generatePDFAndDownload()

			let el = document.getElementById('pdf_element');
			console.log('html code----------------->',el)
			const pdfOptions = { margin: 5,   
			format: 'a4', 
			orientation: 'portrait',
			// pagebreak: { mode: 'avoid-all', before: '.list-item:last-child' },
			};

			const pdf = await html2pdf().from(el).set(pdfOptions).outputPdf().save();

			// await html2pdf().from(el).outputPdf().then(async pdf => {

				// Handle the PDF here

				console.log('pdf----------------->',pdf)

				// Convert PDF to Blob

				const pdfBlob = new Blob([pdf], { type: 'application/pdf' });

				console.log('pdfBlob----------------->',pdfBlob)

				const reader = new FileReader();

				reader.onload = async function() {

				const blobContent = reader.result; // Contains the content of the Blob

				console.log('blobContent------------------->',blobContent);
					const url = await window.URL.createObjectURL(blobContent);

					const a = document.createElement('a');

					a.style.display = 'none';

					a.href = url;

					a.download = 'test.pdf';

					document.body.appendChild(a);

					a.click();

					window.URL.revokeObjectURL(url);
				};

				reader.readAsText(pdfBlob);

				

		

				// Create FormData and append the PDF Blob

				const formData = new FormData();

				await formData.append('file', pdfBlob,'generate.pdf'); // 'pdfFile' is the field name expected by your API

				console.log('formData----------------->',formData.file)

				await this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/uploadfiletos3`,formData)

				.then(result=>console.log('result----------->',result))

				.catch(err=>console.log('err----------->',err))
				this.challanDownloadModal = false;

			// });
		},

		populateChallanData(item){
			this.refObj = {
				"destination_hub_name":"",
				"master_awb":"",
				"driver_name":"",
				"driverMobileNo":"",
				"vehicleInTime":"",
				"vehicleOutTime":"",
				"vehicleNo":"",
				"securityName":"",
				"handoverByName":"",
				"handoverDate":"",
				"handoverTime":"",
				"optional":'',
				"origin_name":'Riyadh LPC',
				"acknowledgement" : "All Shipment Received in Proper Condition with mentioned count",
				"courierCompany": "FirstCry Express",
			}
			let refChallanData = {}
			let existingChallanData = item.challan_data ? JSON.parse(item.challan_data) : {}
			console.log(item)
			refChallanData = {...this.refObj}
			refChallanData = {...refChallanData,"destination_hub_name":item["destination_hub_name"],"master_awb":item["master_awb"]}

			refChallanData = {...refChallanData,...existingChallanData}
			
			console.log("{{challanData.driver_name}}",this.challanData.driver_name)
			this.selectedDriverName = this.challanData.driver_name
			this.selectedhandoverdatachallanData = new Date(item.handoverDate).getFullYear()+'-'+ new Date(item.handoverDate).getMonth() +'-'+ new Date(item.handoverDate).getDate() 
			// this.formatDate(this.challanData.handoverDate) ? this.formatDate(this.challanData.handoverDate) : new Date()
			// refChallanData['handoverDate'] = this.selectedhandoverdatachallanData
			console.log('refChallanData-------------->',refChallanData)
			this.challanData = refChallanData
		},

		showChallanDownloadModal(value)
		{
			this.masteAwbData = value
			console.log("this.masteAwbData",this.masteAwbData)
			this.challanDownloadModal = true;
					const pdfElement = document.getElementById('pdf_el');
			if (pdfElement) {
			this.pdfContent = pdfElement.innerHTML;
			}
			this.masterawbShipmentlist(this.masteAwbData.master_awb)
						
			
		},

		downloadChalla()
		{
			document.getElementById('downloadfooter').style.display  = "none";
			this.generatePDF()
			
		},

		closechallanDownloadModal()
		{
			this.challanDownloadModal = false;
		},

		refresh(){

			this.fromDate = new Date();
			this.toDate = new Date();
			this.createditem = [];
			this.totalRows = 0;
			this.createdMasterawbListForKsa();
			
			//this.getRiderRVPDayWiseListing(1);
      	},

		formatDate: function(date) {
			var d = new Date(date),
				month = "" + (d.getMonth() + 1),
				day = "" + d.getDate(),
				year = d.getFullYear();
			if (month.length < 2) month = "0" + month;
			if (day.length < 2) day = "0" + day;
			return [year, month, day].join("-");
			},
	}
	};
</script>

<style>

.forborder{
	border-right: 1px solid #DBCDCD;
    padding: 10px;
}

.barcodediv {
    margin-left: -85px;
}

#overlay{
    position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
.loader{
    position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

</style>